import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const SettingsCtx = createContext({ settings: null, reload: () => {} });

export const brandingUrl = (id) => (id ? `${API}/public/files/${id}` : "");

export function applyHead(s) {
  document.title = s.page_title || s.site_name;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = s.favicon_file_id ? brandingUrl(s.favicon_file_id) : "/favicon.png";
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      applyHead(data);
    } catch {
      setSettings((s) => s);
    }
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return <SettingsCtx.Provider value={{ settings, reload, setSettings }}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
